var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 6C16 3.79086 14.2091 2 12 2C9.79086 2 8 3.79086 8 6M8 10.5V13.5M16 10.5V13.5M21 12V15.6C21 17.8402 21 18.9603 20.564 19.816C20.1805 20.5686 19.5686 21.1805 18.816 21.564C17.9603 22 16.8402 22 14.6 22H9.4C7.15979 22 6.03968 22 5.18404 21.564C4.43139 21.1805 3.81947 20.5686 3.43597 19.816C3 18.9603 3 17.8402 3 15.6V12M5 12H19C19.9319 12 20.3978 12 20.7654 11.8478C21.2554 11.6448 21.6448 11.2554 21.8478 10.7654C22 10.3978 22 9.93188 22 9V9C22 8.06812 22 7.60218 21.8478 7.23463C21.6448 6.74458 21.2554 6.35523 20.7654 6.15224C20.3978 6 19.9319 6 19 6H5C4.06812 6 3.60218 6 3.23463 6.15224C2.74458 6.35523 2.35523 6.74458 2.15224 7.23463C2 7.60218 2 8.06812 2 9V9C2 9.93188 2 10.3978 2.15224 10.7654C2.35523 11.2554 2.74458 11.6448 3.23463 11.8478C3.60218 12 4.06812 12 5 12Z",
    stroke: "#0D0D0D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.686f6edd38835aeb219c071f6756f28e.svg";
export { ForwardRef as ReactComponent };